import type { TRuleWithTheme } from '@/styles/theme';

export const label: TRuleWithTheme = ({ theme }) => ({
    marginBottom: '0.375rem',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),
});

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
});

export const tooltipButton: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'help',
});

export const tooltipOverlay: TRuleWithTheme = () => ({
    '& .ant-tooltip-inner': {
        width: '420px !important',
    },
});
